import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VersionService {
  constructor(private http: HttpClient) {}

  getVersionInfo() {
    return this.http.get('assets/version.txt', { responseType: 'text' });
  }
}
